import * as Actions from 'actions/base-station';
import { GetResponsiblePersonParams, ResponsiblePerson } from 'models/base-station';
import { Repository } from 'utils/repository';

export type State = Repository<ResponsiblePerson, GetResponsiblePersonParams, 'id'>;
const initState: State = Repository.create('id');

export const reducer = (state: State = initState, action: Actions.Action): State => {
  switch (action.type) {
    case Actions.BASE_STATION_RESPONSIBLE_PERSON_DATA_LOAD_START:
      return state.setFetched(action.params, false);
    case Actions.BASE_STATION_RESPONSIBLE_PERSON_DATA_LOAD_FAILURE:
      return state.setFetched(action.params, true);
    case Actions.BASE_STATION_RESPONSIBLE_PERSON_DATA_LOAD_SUCCESS:
      return state
        .setFetched(action.params, true)
        .setData(action.params, action.data);
    case Actions.BASE_STATION_RESPONSIBLE_PERSON_LOCK:
      return state.setLocked(action.personId, true);
    case Actions.BASE_STATION_RESPONSIBLE_PERSON_UNLOCK:
      return state.setLocked(action.personId, false);
    case Actions.BASE_STATION_RESPONSIBLE_PERSON_CHANGE:
      return state.changeModel(
        action.person.id,
        action.options.delete ? undefined : action.person
      );
    default:
      return state;
  }
};
